export type DateFieldProps = {
  label: string;
  value: string;
  min?: string;
  max?: string;
  onChange: (value: string) => void;
};

export function DateField({ label, value, min, max, onChange }: DateFieldProps) {
  return (
    <label className="flex flex-col gap-1">
      <span className="text-[12px] font-medium text-[color:var(--text-secondary)]">
        {label}
      </span>
      <input
        type="date"
        value={value}
        min={min}
        max={max}
        onChange={(e) => onChange(e.target.value)}
        className="h-10 w-full rounded-[9px] border border-[color:var(--border-light)] bg-[color:var(--surface)] px-3 text-[13px] text-[color:var(--text-primary)] outline-none transition-colors focus:border-[color:var(--accent-500)] focus:ring-2 focus:ring-[color-mix(in_oklab,var(--accent-500)_35%,var(--card))] focus:ring-offset-0"
      />
    </label>
  );
}
